export const START_TIME = '08:00:00';
export const END_TIME = '22:00:00';

export const TOTAL = 4;
